import { PrettyPrintJson } from './PrettyPrintJson';
import { jsx as _jsx } from "react/jsx-runtime";
export function FallbackBlock({
  block
}) {
  return /*#__PURE__*/_jsx("div", {
    "data-block-type": "fallback",
    "data-type": block.type,
    children: /*#__PURE__*/_jsx(PrettyPrintJson, {
      data: block,
      defaultOpen: true
    })
  });
}